module.exports = __webpack_public_path__ + "static/media/user-history-modal.a6f77572.svg";